import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import { debounce } from 'lodash';
import {
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Tabs,
} from 'antd';

import { API_ERRO_TYPE_CANCEL } from './../../config/general';

import {
  integrationsService,
  companiesService,
  departmentsService,
  employeesService,
} from '../../redux/services';

import { DatePickerWithMask, UIDrawerForm } from './../../components';
import TextArea from 'antd/lib/input/TextArea';
import ColumnTable from './table';
import EventColumnTable from './tableEvents';

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`

class Create extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isSending: false,
      type: null,
      autocomplete: null,
      companies: [],
      companiesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
      employees: [],
      employeesIsLoading: false,
      justificationsIsLoading: false,
      justifications: [],
    }

    this._axiosCancelCompaniesToken = null
    this._axiosCancelDepartmentsToken = null
    this._axiosCancelEmployeesToken = null
    this._axiosCancelJustificationsToken = null
  }

  columnTableRef = React.createRef();
  eventColumnTableRef = React.createRef();

  fetchCompanies = () => {
    if (this._axiosCancelCompaniesToken) {
      this._axiosCancelCompaniesToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelCompaniesToken = axios.CancelToken.source()

    this.setState({
      companiesIsLoading: true,
    })

    companiesService
      .getAutocomplete({
        orderBy: 'nome:asc',
        ativo: 1,
        cancelToken: this._axiosCancelCompaniesToken.token,
      })
      .then((response) => {
        this.setState({
          companiesIsLoading: false,
          companies: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          companiesIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartments = (value) => {
    if (this._axiosCancelDepartmentsToken) {
      this._axiosCancelDepartmentsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelDepartmentsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // departmentsIsLoading: false,
        // departments: [],
      // })

      // return false
    // }

    this.setState({
      departmentsIsLoading: true,
    })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelDepartmentsToken.token,
      empresas_ids: this.form.getFieldValue('empresas').includes('todos')
        ? []
        : this.form.getFieldValue('empresas'),
    }

    departmentsService
      .getAutocomplete({
        ...params,
      })
      .then((response) => {
        this.setState({
          departmentsIsLoading: false,
          departments: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          departmentsIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartmentsSearch = debounce(this.fetchDepartments, 500);

  fetchEmployees = (value) => {
    if (this._axiosCancelEmployeesToken) {
      this._axiosCancelEmployeesToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelEmployeesToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // employeesIsLoading: false,
        // employees: [],
      // })

      // return false
    // }

    this.setState({
      employeesIsLoading: true,
    })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelEmployeesToken.token,
      empresas_ids: this.form.getFieldValue('empresas').includes('todos')
        ? []
        : this.form.getFieldValue('empresas'),
      departamentos_ids: this.form
        .getFieldValue('departamentos')
        .includes('todos')
        ? []
        : this.form.getFieldValue('departamentos'),
    }

    employeesService
      .getAutocomplete({
        ...params,
      })
      .then((response) => {
        this.setState({
          employeesIsLoading: false,
          employees: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          employeesIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchEmployeesSearch = debounce(this.fetchEmployees, 500);

  onCompanyChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'empresas',
        value.filter((item) => item !== 'todos')
      )
    }

    this.setState({
      employees: [],
      employeesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
    })

    this.form.setFieldValue('departamentos', ['todos'])
    this.form.setFieldValue('funcionarios', ['todos'])
  }

  onCompanySelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('empresas', ['todos'])
    }
  }

  onDepartmentChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'departamentos',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onDepartmentSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('departamentos', ['todos'])
    }
  }

  onEmployeeChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'funcionarios',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onEmployeeSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('funcionarios', ['todos'])
    }
  }

  onOpen = () => {
    if (!this.state.companies.length) {
      this.fetchCompanies()
    }

    setTimeout(() => {
      this.nome && this.nome.focus()
      this.form &&
        this.form.setFieldsValue({
          status: 1,
        })
    }, 100)
  }

  resetFields = () => {
    this.setState({
      companies: [],
      companiesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
      employees: [],
      employeesIsLoading: false,
      justifications: [],
      justificationsIsLoading: false,
    })
  }

  onClose = () => {
    // Reset fields
    this.resetFields()
    // Callback
    this.props.onClose()
  }

  validateColumnData = (columnData) => {
    if (!Array.isArray(columnData) || columnData.length === 0) return false;
    for (const item of columnData) {
      const hasColumn = item && typeof item.column === 'string' && item.column.trim() !== '';
      if (!hasColumn) return false;
      if (item.column === 'TEXTO_FIXO') {
        const hasValue = typeof item.eventCode === 'string' ? item.eventCode.trim() !== '' : !!item.eventCode;
        if (!hasValue) return false;
      } else {
        if (!item.type) return false;
      }
    }
    return true;
  };

  normalizeEventRows = (rows) => {
    if (!Array.isArray(rows)) return [];
    return rows.map((r) => {
      const base = {
        eventType: r?.eventType ?? undefined,
        eventCode: r?.eventCode ?? '',
        separator: r?.separator ?? '',
      };

      // SEMPRE incluir "columns" quando for total_falta_dia,
      // mesmo que vazio ([])
      if (r?.eventType === 'total_falta_dia') {
        const cols = Array.isArray(r?.columns) ? r.columns : [];
        return { ...base, columns: cols };
      }

      return base;
    });
  };

  getEventColumnPayload = async () => {
    const child = this.eventColumnTableRef?.current;
    if (!child) return [];
    if (typeof child.getPayload === 'function') {
      const rows = await child.getPayload(); // pode ser async
      return this.normalizeEventRows(rows);
    }
    if (typeof child.getFormData === 'function') {
      const rows = await child.getFormData(); // compat
      return this.normalizeEventRows(rows);
    }
    return [];
  };

  validateEventColumnData = (rows) => {
    if (!Array.isArray(rows)) return true;
    for (const r of rows) {
      if (r?.eventType === 'total_falta_dia' && r?.columns) {
        if (!Array.isArray(r.columns)) return false;
        for (const item of r.columns) {
          const hasColumn = item && typeof item.column === 'string' && item.column.trim() !== '';
          if (!hasColumn) return false;
          if (item.column === 'TEXTO_FIXO') {
            const hasValue = typeof item.eventCode === 'string' ? item.eventCode.trim() !== '' : !!item.eventCode;
            if (!hasValue) return false;
          } else {
            if (!item.type) return false;
          }
        }
      }
    }
    return true;
  };

  onFinish = async (values) => {
    this.setState({ isSending: true });

    const columnData = await this.columnTableRef.current.getFormData();
    const eventColumnData = await this.getEventColumnPayload();

    const data = {
      ...values,
      eventData: columnData,
      eventColumnData
    };

    if (!this.validateColumnData(columnData)) {
      message.error('Preencha os dados de Coluna e/ou Código corretamente!');
      this.setState({ isSending: false });
      return;
    }

    if (!this.validateEventColumnData(eventColumnData)) {
      message.error('Revise os Eventos: quando detalhar o total_falta_dia, informe os dados corretamente.');
      this.setState({ isSending: false });
      return;
    }

    if (!(data.empresas instanceof Array)) data.empresas = [data.empresas];
    if (!(data.departamentos instanceof Array)) data.departamentos = [data.departamentos];
    if (!(data.funcionarios instanceof Array)) data.funcionarios = [data.funcionarios];

    if (data.empresas.includes('todos')) data.empresas = null;
    if (data.departamentos.includes('todos')) data.departamentos = null;
    if (data.funcionarios.includes('todos')) data.funcionarios = null;

    integrationsService
      .create(data)
      .then(() => {
        this.setState({ isSending: false });
        this.resetFields();
        message.success('Integração cadastrada com sucesso.');
        this.props.onComplete();
      })
      .catch((err) => {
        this.setState({ isSending: false });
        Modal.error({ title: 'Ocorreu um erro!', content: String(err) });
      })
  }

  render() {
    const { visible } = this.props
    const {
      isLoading,
      isSending,
      companiesIsLoading,
      companies,
      departments,
      departmentsIsLoading,
      employees,
      employeesIsLoading,
    } = this.state

    return (
      <UIDrawerForm
        visible={visible}
        width={800}
        onClose={this.onClose}
        isLoading={isLoading}
        isSending={isSending}
        formId={formId}
        title="Incluir Nova Integração"
      >
        <Form
          ref={(el) => (this.form = el)}
          id={formId}
          layout="vertical"
          scrollToFirstError
          onFinish={this.onFinish}
          initialValues={{
            required: true,
            status: true,
            empresas: ['todos'],
            departamentos: ['todos'],
            funcionarios: ['todos'],
            layout: '',
          }}
        >
          <Tabs>
            <Tabs.TabPane forceRender tab="Info. Gerais" key="general">
              <Row gutter={16}>
                <Col xs={24}>
                  <Form.Item
                    name="empresas"
                    label="Empresa"
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                  >
                    <Select
                      ref={(el) => (this.empresas = el)}
                      mode="multiple"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (typeof option.children === 'string'
                          ? option.children
                          : option.children.props.children
                        )
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      allowClear
                      placeholder="Selecione a(s) empresa(s)"
                      notFoundContent={
                        companiesIsLoading ? (
                          <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                        ) : null
                      }
                      onChange={this.onCompanyChange}
                      onSelect={this.onCompanySelect}
                      showSearch
                    >
                      <Select.Option value="todos">Todas</Select.Option>
                      {companies.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="departamentos"
                    label="Departamento"
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                  >
                    <Select
                      mode="multiple"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (typeof option.children === 'string'
                          ? option.children
                          : option.children.props.children
                        )
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      allowClear
                      placeholder="Selecione o(s) departamento(s)"
                      notFoundContent={
                        departmentsIsLoading ? (
                          <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                        ) : null
                      }
                      onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
                      onSearch={this.fetchDepartmentsSearch}
                      onChange={this.onDepartmentChange}
                      onSelect={this.onDepartmentSelect}
                      showSearch
                    >
                      <Select.Option value="todos">Todos</Select.Option>
                      {departments.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="funcionarios"
                    label="Funcionário"
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                  >
                    <Select
                      mode="multiple"
                      filterOption={false}
                      allowClear
                      placeholder="Selecione o(s) funcionário(s)"
                      notFoundContent={
                        employeesIsLoading ? (
                          <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                        ) : null
                      }
                      onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
                      onSearch={this.fetchEmployeesSearch}
                      onChange={this.onEmployeeChange}
                      onSelect={this.onEmployeeSelect}
                      showSearch
                    >
                      <Select.Option value="todos">Todos</Select.Option>
                      {employees.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="layout" label="Descrição Layout">
                    <Input style={{ width: "100%" }} placeholder="Descrição" />
                  </Form.Item>
                  <Row gutter={16}>
                    <Col xs={24}>
                      <ColumnTable ref={this.columnTableRef} />
                    </Col>
                  </Row>
                  <Form.Item name="description" label="Descrição" hasFeedback>
                    <TextArea
                      ref={(el) => (this.motivo = el)}
                      placeholder="Descrição"
                      autoSize={{ minRows: 2, maxRows: 5 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Tabs.TabPane>

            <Tabs.TabPane forceRender tab="Eventos" key="eventos" >
              <Row gutter={16}>
                <Col xs={24}>
                  <EventColumnTable ref={this.eventColumnTableRef} />
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </UIDrawerForm>
    )
  }
}

export default Create
